<template>
    <div class="page">
        <Section>
            <h1 class="text-h3 font-weight-bold mb-2">{{ t('contact_page.title') }}</h1>
            <p class="text-medium-emphasis mb-8">{{ t('contact_page.subtitle') }}</p>
            <div class="contact-actions d-flex flex-column ga-4">
                <v-btn
                    color="primary"
                    size="large"
                    :href="`mailto:${email}`"
                    >{{ t('contact_page.email_label') }}: {{ email }}</v-btn
                >
                <v-btn
                    variant="outlined"
                    size="large"
                    :href="githubUrl"
                    target="_blank"
                    rel="noopener"
                    >{{ t('contact_page.github_label') }}: {{ githubHandle }}</v-btn
                >
                <v-btn
                    variant="outlined"
                    size="large"
                    :href="`tel:${phone.replace(/\s/g, '')}`"
                    >{{ t('contact_page.phone_label') }}: {{ phone }}</v-btn
                >
            </div>
        </Section>
    </div>
</template>

<script setup lang="ts">
    import Section from '@/components/Section.vue'
    import { useTranslations } from '@/composables/useTranslations'
    import { useSEO } from '@/composables/useSEO'

    const { t } = useTranslations()
    useSEO({
        title: () => t('seo.contact.title'),
        description: () => t('seo.contact.description'),
    })
    const email = t('contact.email')
    const phone = import.meta.env.VITE_CONTACT_PHONE ?? '+49 172 511 2820'
    const githubUrl = import.meta.env.VITE_GITHUB_URL ?? 'https://github.com/BentBr'
    const githubHandle = githubUrl.split('/').filter(Boolean).pop()
</script>

<style scoped>
    .page {
        padding-top: 80px;
    }

    /* Keep the CTA stack from stretching the full container width. */
    .contact-actions {
        max-width: 560px;
    }
</style>
